import { diagnosticSettings, diagnosticParameters } from './shared.js';

export default {
  label: 'Paraxial Ray Trace', group: 'system',
  description: 'Paraxial marginal and chief ray heights and angles at each surface. Angles are in radians.',
  settingsSchema: diagnosticSettings,
  parameters: diagnosticParameters,
  coverage: 'The entrance pupil and image rows are always shown, even when you select a surface range. The lens\'s XZ setting chooses whether the X or Y plane is traced.',
} as const;
